module.exports = __webpack_public_path__ + "2026 Qualified Parking User Guide.pdf";